import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_FEATURED_SPIKING_PETITION_EXPERIMENT = defineFcm('psf_featured_spiking_petition_experiment')
	.asJson(
		z.object({
			experimentName: z.string().optional(),
			petitions: z.array(z.object({ id: z.number().int() })).optional(),
		}),
	)
	.withDefault({ experimentName: undefined, petitions: [] })
	.toConfig({
		owner: 'squad-platypus',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF combo page (featured spiking petition step)',
		description: `Gates the PSF featured spiking petition experiment (CHANGE-102055), which shows a spiking petition with
			one-tap Sign after the signer skips the combo page (v1) or returns from sharing (v2). The experiment is enabled only
			when experimentName is set and petitions lists at least one petition. The first petition the viewer can still sign
			is featured; remove a petition here to take it off within minutes. Set only the en-US locale row: this FCM is what
			limits the experiment to en-US, so a global or country row would enable it for other locales.`,
		supportedGroups: { locales: true, countries: true },
		template: {
			experimentName: 'psf_featured_spiking_petition_experiment',
			petitions: [{ id: 123456 }],
		},
	});
